<template>
  <div>
    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="agent_bill_id"
    >
      <div slot="no" slot-scope="no, record">
        <router-link
          :to="{ name: 'monthly_bill_renew_order_info_commission',
                 params: { renew_order_id: record.agent_renew_order_id },
                 query: { bill_id: billId }}"
        >
          {{ no }}
        </router-link>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { findRenewBills } from '@/api/agent_monthly_bill'
import { formatBigNumber, formatCurrency } from '@/utils/filter'

export default {
  name: 'AgentRenewBillList',
  components: {
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  props: {
    billId: {
      type: Number,
      required: true
    }
  },
  computed: {
    agentType() {
      return this.$store.getters.userAgentType
    },

    columns() {
      var columnArr = [
        {
          title: '订单批次',
          dataIndex: 'no',
          width: 150,
          scopedSlots: { customRender: 'no' }
        },
        {
          title: '订单时间',
          width: 200,
          dataIndex: 'created_at'
        },
        {
          title: '操作人',
          width: 200,
          dataIndex: 'operator_name'
        },
        {
          title: '卡号数量',
          dataIndex: 'cards_count',
          width: 100,
          customRender: formatBigNumber
        },
        {
          title: '续期周期数',
          dataIndex: 'cycles',
          width: 100,
          customRender: formatBigNumber
        },
        {
          title: '订单金额(元)',
          dataIndex: 'total_fee',
          width: 100,
          customRender: formatCurrency
        },
        {
          title: '佣金金额(元)',
          dataIndex: 'commission_fee',
          width: 100,
          customRender: formatCurrency
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 100,
          ellipsis: true
        }
      ]

      return columnArr
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findRenewBills(this.billId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }

        this.loading = false
      })
    }
  }
}
</script>

